import React, { useContext } from "react";
import { FaMapMarkerAlt, FaSearch, FaChevronDown } from "react-icons/fa";
import { AppContext } from "../AppContext";

const SearchBar = () => {
  const {
    activeTab,
    setActiveTab,
    selectedLocation,
    setSelectedLocation,
  } = useContext(AppContext);

  const handleSearch = () => {
    alert(`Searching for ${activeTab} properties in ${selectedLocation}`);
  };

  return (
    <div className="bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 shadow-lg p-8 rounded-xl">
      {/* Tabs */}
      <div className="flex justify-center mb-4">
        <button
          className={`px-6 pb-2 text-lg font-semibold transition-all duration-300 border-b-4 ${
            activeTab === "buy"
              ? "border-primaryOrange text-gray-800"
              : "border-gray-300 text-gray-500 hover:text-gray-800"
          }`}
          onClick={() => setActiveTab("buy")}
        >
          Buy
        </button>
        <button
          className={`px-6 pb-2 text-lg font-semibold transition-all duration-300 border-b-4 ml-4 ${
            activeTab === "rent"
              ? "border-primaryOrange text-gray-800"
              : "border-gray-300 text-gray-500 hover:text-gray-800"
          }`}
          onClick={() => setActiveTab("rent")}
        >
          Rent
        </button>
      </div>

      {/* Search Section */}
      <div className="flex items-center justify-between bg-white bg-opacity-90 p-6 rounded-xl shadow-md">
        {/* Location Dropdown */}
        <div className="flex items-center space-x-3 relative">
          <FaMapMarkerAlt className="text-primaryOrange text-lg" />
          <div className="relative w-48">
            <select
              id="location"
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
              className="appearance-none w-full p-2 bg-transparent text-gray-800 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-primaryOrange"
            >
              {["Mumbai", "Pune", "Bangalore", "Chennai", "Noida", "Hyderabad", "Lucknow"].map(
                (location) => (
                  <option key={location} value={location}>
                    {location}
                  </option>
                )
              )}
            </select>
            {/* Dropdown Icon */}
            <FaChevronDown className="absolute right-2 top-2.5 text-gray-500 pointer-events-none" />
          </div>
        </div>

        {/* Search Bar */}
        <div className="flex items-center space-x-4 w-3/5">
          <input
            type="text"
            placeholder={`Search for ${activeTab} properties`}
            className="flex-grow p-3 bg-gray-100 text-gray-800 border border-gray-300 rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primaryOrange"
          />
          <button
            onClick={handleSearch}
            className="flex items-center justify-center bg-primaryOrange text-white py-3 px-6 rounded-lg shadow-lg hover:bg-orange-600 transition duration-300"
          >
            <FaSearch className="text-lg mr-2" />
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
